import { Tab as MUITab, type TabProps as MUITabProps } from '@mui/material'
import { forwardRef } from 'react'
import type { LinkProps } from 'react-router-dom'
import { Link } from '@/helpers/Link'

//	///////////////////////
//	MARK: TYPES
export type TTabLinkProps = MUITabProps & LinkProps

//	///////////////////////
//	MARK: EXPORTS
export const TabLink = forwardRef<HTMLAnchorElement, TTabLinkProps>((props, ref) => (
  <MUITab component={Link} ref={ref} {...props} />
))
